import { Tooltip, Table } from 'antd';
import AntdTable from 'components/AntdTable';
import useErrorNetworkMessage from 'hook/useErrorNetworkMessage';
import useModalConfirm from 'hook/useModalConfirm';
import { TooltipHide } from 'page/Application/ManageCompanyList/CompanyList/styled';
import { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import useMultiLanguageEnterpriseLog from '../hook/useMultiLanguageEnterpriseLog';

const AccountAccessRankingTable = ({ dataRaw, isLoading, emptyText }) => {
  const navigate = useNavigate();

  const {
    ACCOUNT_ACCESS_RANKING_TABLE_PAGE_TITLE,
    ACCOUNT_ACCESS_RANKING_TABLE_PRODUCT_NAME,
    ACCOUNT_ACCESS_RANKING_TABLE_COUNT,
  } = useMultiLanguageEnterpriseLog();

  const { contextHolder } = useModalConfirm();
  const { isOnline, errorNetWork, contextErrorNetWork } =
    useErrorNetworkMessage();

  const columns = useMemo(() => {
    return [
      Table.SELECTION_COLUMN,
      {
        key: 'rank',
        title: (
          <TooltipHide>
            <Tooltip title="ランキング" placement={'topLeft'}>
              ランキング
            </Tooltip>
          </TooltipHide>
        ),
        dataIndex: 'rank',
        align: 'left',
        width: 120,
        render: (rank) => (
          <TooltipHide>
            <Tooltip title={rank} placement={'topLeft'}>
              {rank}
            </Tooltip>
          </TooltipHide>
        ),
      },
      {
        key: 'pageTitle',
        title: (
          <TooltipHide>
            <Tooltip
              title={ACCOUNT_ACCESS_RANKING_TABLE_PAGE_TITLE}
              placement={'topLeft'}
            >
              {ACCOUNT_ACCESS_RANKING_TABLE_PAGE_TITLE}
            </Tooltip>
          </TooltipHide>
        ),
        dataIndex: 'pageTitle',
        align: 'left',
        ellipsis: true,
        render: (pageTitle) => (
          <TooltipHide>
            <Tooltip title={pageTitle} placement={'topLeft'}>
              {pageTitle}
            </Tooltip>
          </TooltipHide>
        ),
      },
      {
        key: 'productName',
        title: (
          <TooltipHide>
            <Tooltip
              title={ACCOUNT_ACCESS_RANKING_TABLE_PRODUCT_NAME}
              placement={'topLeft'}
            >
              {ACCOUNT_ACCESS_RANKING_TABLE_PRODUCT_NAME}
            </Tooltip>
          </TooltipHide>
        ),
        dataIndex: 'productName',
        align: 'left',
        ellipsis: true,
        width: 180,
        render: (productName) => (
          <TooltipHide>
            <Tooltip title={productName} placement={'topLeft'}>
              {productName}
            </Tooltip>
          </TooltipHide>
        ),
      },
      {
        key: 'count',
        title: (
          <TooltipHide>
            <Tooltip
              title={ACCOUNT_ACCESS_RANKING_TABLE_COUNT}
              placement={'topLeft'}
            >
              {ACCOUNT_ACCESS_RANKING_TABLE_COUNT}
            </Tooltip>
          </TooltipHide>
        ),
        dataIndex: 'count',
        align: 'left',
        width: 90,
        render: (count) => (
          <TooltipHide>
            <Tooltip title={count?.toLocaleString()} placement={'topLeft'}>
              {count?.toLocaleString()}
            </Tooltip>
          </TooltipHide>
        ),
      },
    ];
  }, [navigate, isOnline, errorNetWork]);

  // format data for render table
  const dataSource = useMemo(() => {
    if (isLoading && !dataRaw) return [];
    return dataRaw?.list?.map((item) => ({
      ...item,
      key: item.rank,
    }));
  }, [dataRaw, isLoading]);

  return (
    <>
      {contextHolder}
      {contextErrorNetWork}
      <AntdTable
        columns={columns}
        isLoading={isLoading}
        dataSource={dataSource}
        emptyText={emptyText}
      />
    </>
  );
};

export default AccountAccessRankingTable;
